"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var dealerDetailsStyles = styles_1.makeStyles(function (theme) { return ({
    dealerDistance: {
        display: 'flex',
        flex: 'auto',
        justifyContent: 'end',
        color: theme.palette.common.black,
    },
    dealerDistanceUnit: {
        marginLeft: 4,
        '& span': {
            fontWeight: 'bold',
        },
    },
    geoNotSupported: {
        maxWidth: 100,
    },
}); }, { name: 'Checkout_DealerDistance' });
exports.default = dealerDetailsStyles;
